// extracted by mini-css-extract-plugin
export default {"wave-container":"index_wave-container__VePbV","wave":"index_wave__Y0VFy","audioWave":"index_audioWave__9+E55"};